import * as TP from '../subscriptionTypes';

import { gql } from '@apollo/client';
export type StopEventAuditStatusEventPayloadFragment = (
  { readonly __typename?: 'StopEventAuditStatusEvent' }
  & Pick<TP.StopEventAuditStatusEvent, 'id' | 'stopID' | 'eventStatus' | 'auditType' | 'message'>
);

export const StopEventAuditStatusEventPayloadFragmentDoc = gql`
    fragment StopEventAuditStatusEventPayload on StopEventAuditStatusEvent {
  id
  stopID
  eventStatus
  auditType
  message
}
    `;